import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const threatExchange = defineConnector({
  identifier: "threatExchange",
  name: "ThreatExchange",
  tagLine: "Meta threat intelligence sharing",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://graph\\.facebook\\.com/.*",
  auth: (app) =>
    queryAuth([{ name: "access_token", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Collect the required credentials for ThreatExchange",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://developers.facebook.com/docs/threat-exchange/](https://developers.facebook.com/docs/threat-exchange/) to create the credential values this API expects on each request.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "input",
          label: "Graph API version",
          placeholder: "v23.0",
          target: {
            kind: "configuration",
            field: "version",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://graph.facebook.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ??
        (({ version = "v23.0" }) =>
          `https://graph.facebook.com/${version}/threat_indicators`)(
          configuration
        ),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
